<script setup>

import {useAttrs} from "vue";
import Navigation from "@/Pages/Homepage/cards/Navigation.vue";
import Footer from "@/Pages/Homepage/cards/Footer.vue";

const attrs = useAttrs();

</script>

<template>
	<div class="min-h-screen relative">

		<!-- Navigation -->
		<Navigation :auth="attrs.auth"/>

		<!-- Hero Section -->
		<main class="max-w-4xl mx-auto px-6 pt-20 pb-16 grid gap-4 font-dmsans">
			<h1 class="text-4xl font-funnel">Limited Use Agreement</h1>
			<p>Effective as of 1/1/2024</p>


			<section class="grid gap-6">

				<h3 class="text-2xl font-funnel mt-8">
					Google API Services Usage Disclosure
				</h3>

				<p>
					SlideCub's use and transfer of information received from Google APIs to any other app will adhere to <a href="https://developers.google.com/terms/api-services-user-data-policy#additional_requirements_for_specific_api_scopes">Google API Services User Data Policy</a>, including the Limited Use requirements.
				</p>

			</section>

			<section class="grid gap-6">

				<h3 class="text-2xl font-funnel mt-8">
					Limited Use
				</h3>

				<p>Our app strictly complies with all conditions specified in the limited use policy of Google.</p>

				<ul class="list-disc pl-12">
					<li>Do not allow humans to read the user's data unless you have obtained the user's affirmative agreement to view specific messages, files, or other data.</li>
					<li>Do not use or transfer the data for serving ads, including retargeting, personalized, or interest-based advertising; and</li>
					<li>Limit your use of data to providing or improving user-facing features that are prominent in the requesting application's user interface. All other uses of the data are prohibited;</li>
					<li>Only transfer the data to others if necessary to provide or improve user-facing features that are prominent in the requesting application's user interface.</li>
				</ul>

			</section>
		</main>

		<Footer />

	</div>
</template>

<style scoped>

</style>